module.exports = __webpack_public_path__ + "img/copy.1a2f22fd.svg";